import { useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {
  Modal,
  Backdrop,
  Fade,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';

export default function LivemeetingAnalytics({ classes, room }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Tooltip title='Analytics'>
        <IconButton
          aria-label='more'
          aria-controls='long-menu'
          aria-haspopup='true'
          className={classes.toolbarButtons}
          onClick={handleOpen}
        >
          <AssessmentIcon />
        </IconButton>
      </Tooltip>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              backgroundColor: 'white',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}
          >
            <span className='close-modal' onClick={handleClose}>
              &times;
            </span>
            <h6
              id='transition-modal-title'
              style={{ display: 'flex', justifyContent: 'center' }}
            ></h6>
            <h6 style={{ display: 'flex', justifyContent: 'center' }}>
              Meeting Id: {sessionStorage.getItem('meetingSessionId')}
            </h6>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
